import { IGetArqDisciplinasArquivosUseCase } from "../../../presentation/useCases/read/get_arquivo_disciplina_arquivo_use_case";
import { IProjetosRepository } from "../../repositories/projetos_repository";

export class GetArqDisciplinasArquivosUseCase implements IGetArqDisciplinasArquivosUseCase {
  constructor(private readonly repository: IProjetosRepository) { }

  async getArquivo(
    idDisciplinaArquivo: number,
    imagePosition: number,
    imageName: string,
  ): Promise<void> {

    // 1. Recebe o arquivo físico (Blob)
    const blob = await this.repository.getDisciplinaArquivoById(idDisciplinaArquivo, imagePosition);

    if (!blob) throw new Error('Falha ao buscar dados da imagem!');

    // 2. Faz o download nativo do Blob sem travar a tela
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', imageName); // Define o nome do arquivo que vai baixar
    document.body.appendChild(link);
    link.click(); // Simula o clique do usuário para baixar

    // 3. Limpeza de memória
    link.remove();
    window.URL.revokeObjectURL(url);
  }
}